import React from "react";
import { useTranslation } from "react-i18next";

const TeamMemberCard = ({ member }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  // Safe access for multilingual fields
  const getLocalizedText = (field) => {
    if (!field) return "";
    if (typeof field === "string") return field;
    return field[lang] || field.fr || field.en || "";
  };

  const role = getLocalizedText(member.role);
  const bio = getLocalizedText(member.bio);

  return (
    <div
      className="group bg-card rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500"
      data-testid={`team-member-${member.id}`}
    >
      {/* Image */}
      <div className="relative h-80 overflow-hidden">
        <img
          src={member.image_url}
          alt={member.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        
        {/* Experience Badge */}
        {member.experience_years && (
          <div className="absolute top-4 right-4">
            <div className="bg-white/90 backdrop-blur-sm rounded-full px-3 py-1">
              <span className="text-sm font-semibold text-secondary">
                {member.experience_years} {t("team.experience")}
              </span>
            </div>
          </div>
        )}

        {/* Name & Role */}
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h3 className="font-serif text-2xl font-semibold text-white mb-1">
            {member.name}
          </h3>
          <p className="text-primary font-medium">
            {role}
          </p>
        </div>
      </div>

      {/* Bio */}
      <div className="p-6">
        <p className="text-muted-foreground leading-relaxed">
          {bio}
        </p>
      </div>
    </div>
  );
};

export default TeamMemberCard;
